<template>
  <div class="nav-mobile__bottom">
    <ul class="nav-panel__links">

      <li
        class="nav-panel__link-item"
        :class="[ $route.name === 'members' && $route.hash !== '#Visitors' ? 'nav-panel__link-item--active' : '' ]"
      >
        <router-link :to="{ name: 'members' }" class="nav-panel__link">
          <div @click="clearMembersStore" class="nav-panel__link-button">
            <img
              v-if="$route.name === 'members'"
              src="../../../images/menu/members-active.svg"
              alt=""
              class="nav-panel__icon"
            >
            <img
              v-if="$route.name !== 'members'"
              src="../../../images/menu/members.svg"
              alt=""
              class="nav-panel__icon"
            >
          </div>
          <span @click="clearMembersStore" class="nav-panel__link-label">{{ trans.get('top_bar.members') }}</span>
        </router-link>
      </li>

      <li
        class="nav-panel__link-item nav-panel__link-item--accented"
        :class="{'nav-panel__link-item--active': $route.name === 'match_game'}"
      >
        <router-link :to="{name: 'match_game'}" class="nav-panel__link">
          <div class="nav-panel__link-button">
            <img
              v-if="$route.name === 'match_game'"
              src="../../../images/menu/match-active.svg"
              alt=""
              class="nav-panel__icon"
            >
            <img
              v-if="$route.name !== 'match_game'"
              src="../../../images/menu/match.svg"
              alt=""
              class="nav-panel__icon"
            >
          </div>
          <span class="nav-panel__link-label">{{ trans.get('top_bar.match_game') }}</span>
        </router-link>
      </li>

      <li
        class="nav-panel__link-item nav-panel__link-item--chat"
        :class="{'nav-panel__link-item--active': $route.name === 'chat'}"
      >
        <router-link :to="{name: 'chat'}" class="nav-panel__link">
          <div class="nav-panel__link-button">
            <img
              v-if="$route.name === 'chat'"
              src="../../../images/menu/chat-active.svg"
              alt=""
              class="nav-panel__icon"
            >
            <img
              v-if="$route.name !== 'chat'"
              src="../../../images/menu/chat.svg"
              alt=""
              class="nav-panel__icon"
            >
          </div>

          <span class="nav-panel__link-label">{{ trans.get('top_bar.messages') }}</span>
          <chat-unread-messages-component></chat-unread-messages-component>
        </router-link>
      </li>

    </ul>
  </div>
</template>

<script>
import ClearMembersStore from '../../../../js/front/views/elements/ClearMembersStore';

export default {
  name: 'BottomMobileMenu',
  components: {},
  mixins: [ClearMembersStore],
  props: {},
  data() {
    return {};
  },
  methods: {},
  mounted() {
  }
};
</script>
